import { useCallback } from "react";
import { downloadBlobFile } from "../../utils";

export const useDownloadCSV = () => {
  const getCSVBlob = useCallback((headers: string[], data: Array<Record<string, string>>): Blob => {
    let csvContent = "";
    csvContent += `${headers.map(header => `"${header}"`).join(",")}\n`;
    data.forEach(row => {
      const values = headers.map(header => {
        let value = row[header]?.toString() ?? "";
        if (value) {
          value = value.replace(/"/g, '""');
        }
        if (value.includes(",") || value.includes('"')) {
          value = `"${value}"`;
        }
        return value;
      });
      csvContent += `${values.join(",")}\n`;
    });
    const blob = new Blob([csvContent], { type: "text/csv" });
    return blob;
  }, []);

  const downloadCSV = useCallback(
    (headers: string[], data: Array<Record<string, string>>, fileName: string) => {
      const blob = getCSVBlob(headers, data);
      downloadBlobFile(blob, fileName);
    },
    [getCSVBlob]
  );

  return {
    getCSVBlob,
    downloadCSV
  };
};
